<style>
  button {
    background-color: #c80;
    flex: 0 0 auto;
    font-size: 0.8em;
    margin: 0.5em; /* top | right | bottom | left */
    padding: 0.2em;
    width: 4.0em;
  }
  .desc {
    font-size: 0.8em;
    margin: 0.2em;
    padding: 0.3em;
  }
  .first-row {
    align-items: center;
    display: flex;
    flex-flow: row;
  }
  .item {
    align-items: left;
    background-color: #ffe;
    border-radius: 0.2em;
    border-width: 0em;
    box-shadow: 0.1em 0.1em 0.2em #555;
    display: flex;
    flex-flow: column;
    margin: 0.3em 0.4em 0.3em 0.4em; /* top | right | bottom | left */
    padding: 0.2em;
  }
  .more {
    cursor: pointer;
    flex: 0 0 auto;
    font-size: 0.8em;
    margin: 0.3em 0.5em 0.3em 0.3em; /* top | right | bottom | left */
    padding: 0.3em;
  }
  .name {
    cursor: pointer;
    flex: 1 1 auto;
    margin: 0em;
    padding: 0.5em;
  }
  .visible {
    background-color: #373;
  }
  .legend {
    object-fit: scale-down;
    /*width: 50%;*/
    margin-bottom: 0.4em;
  }
</style>

<script>
  import layers from '../../layers';
  import {
    auth_logged_in,
    lang,
    layer_selected, layers_visible,
    leaflet_layers, leaflet_map,
    panel_selected,
  } from '../store';
  import sync from '../sync';
  import util from '../util';
  import { onMount } from 'svelte';

  // function activateEko4() {
  //   const urlHash = window.location.hash; 
  //   if (urlHash === '#eko4') {
  //     Object.keys($layers_visible).forEach(id => {
  //       if ($leaflet_map.hasLayer($leaflet_layers[id])) {
  //         $leaflet_map.removeLayer($leaflet_layers[id]);
  //       }
  //     });

  //     $layers_visible = {};

  //     if ('18_eko4_2024' in $leaflet_layers) {
  //       $leaflet_map.addLayer($leaflet_layers['18_eko4_2024']);
  //       $layers_visible['18_eko4_2024'] = 'on';
  //     }

  //     $layers_visible = { ...$layers_visible };
  //   }
  // }

  // onMount(() => {
  //   activateEko4();
  // });
  
  function toggle_visible (event) {
    if (visible) {
      if ($leaflet_map.hasLayer(layer_obj)) {
        $leaflet_map.removeLayer(layer_obj);
      }
      delete $layers_visible[layer_id];
      $layers_visible = $layers_visible;
    } else {
      if (!$leaflet_map.hasLayer(layer_obj)) {
        $leaflet_map.addLayer(layer_obj);
      }
      $layers_visible[layer_id] = 'on';
      $layers_visible = $layers_visible;
    }
    if (window.innerWidth < 800) {
      $panel_selected = '';
    }
    if ($auth_logged_in) {
      sync.update_user({layers: $layers_visible});
    }
  }

  function toggle_selected() {
    if ($layer_selected === layer_id) {
      $layer_selected = '';
    } else {
      $layer_selected = layer_id;
    };
  }
  export let item_id;
  let layer_id = item_id;
  
  let layer_config = '';
  let layer_obj = '';
  if (layer_id in layers && layer_id in $leaflet_layers) {
    layer_config = layers[layer_id];
    layer_obj = $leaflet_layers[layer_id];
  } else {
    console.error(`Unknown layer_id ${layer_id}`);
  }
  $: visible = $layers_visible[layer_id] === 'on';
</script>

{#if layer_config && layer_obj}
  <div class='item'>
    <div class='first-row'>
      <button class:visible on:click={toggle_visible}>{visible ? util.caption($lang,'layer_panel','visible') : util.caption($lang,'layer_panel','hidden')}</button>
      <p class='name' on:click={toggle_visible}>
      {util.caption($lang,'layer_name',layer_id)}</p>
      <p class='more' on:click={toggle_selected}>{$layer_selected === layer_id ? util.caption($lang,'layer_panel','less') : util.caption($lang,'layer_panel','more')}</p>
    </div>
    {#if $layer_selected === layer_id}
      <p class='desc'>
        {util.caption($lang,'layer_desc',layer_id)}
        {#if layer_config.info}
          <a href='{layer_config.info}' rel='noopener noreferrer' target='_blank'>{util.caption($lang,'layer_panel','details')}</a>
        {/if}
      </p>
      {#if layer_config.legend}
        <p class='desc'>{util.caption($lang,'layer_panel','legend')}:</p>
        <img class='legend' src='{layer_config.legend}' alt='{util.caption($lang,'layer_panel','legend')}' width='{layer_config.legend_width}'/>
      {/if}
      {#if layer_config.project}
        <p class='desc'>{util.caption($lang,'layer_panel','project')}:</p>
        <img class='legend' src='{layer_config.project}' alt='{util.caption($lang,'layer_panel','project')}' width='{layer_config.project_width}'/>
      {/if}
    {/if}
  </div>
{/if}
